const DefaultBatteryTypes = {
    LG: {
      maxDCBPower: 1500,
      capacity: 6.5
    },
    ATL: {
      maxDCBPower: 1500,
      capacity: 3.25
    }
};

export default DefaultBatteryTypes;
